<template>
  <div class="page_container_wrapper">
    <div class="page_container">
      <transition name="fade-in-up">
        <step-intro
          v-if="activeStep === 'intro'"
          step-name="intro"
        ></step-intro>
        <step-questions
          v-if="activeStep === 'questions'"
          step-name="questions"
        ></step-questions>
        <step-company-information
          v-if="activeStep === 'companyInformation'"
          step-name="companyInformation"
        ></step-company-information>
        <step-contact-information
          v-if="activeStep === 'contactInformation'"
          step-name="contactInformation"
        ></step-contact-information>
        <step-contract
          v-if="activeStep === 'contract'"
          step-name="contract"
        ></step-contract>
        <step-thanks v-if="allStepsCompleted"></step-thanks>
      </transition>
    </div>
  </div>
</template>

<script>
import StepIntro from './intro/';
import StepQuestions from './questions/';
import StepCompanyInformation from './companyInformation/';
import StepContactInformation from './contactInformation/';
import StepContract from './contract/';
import StepThanks from './thanks/';

export default {
  name: 'ApplicationsSupplierSteps',
  components: {
    StepIntro,
    StepQuestions,
    StepCompanyInformation,
    StepContactInformation,
    StepContract,
    StepThanks,
  },
  computed: {
    activeStep() {
      return this.$store.getters['supplier/getActiveStep'];
    },
    allStepsCompleted() {
      return this.$store.getters['supplier/getAllStepsCompleted'];
    },
  },
};
</script>
